/* eslint-disable prettier/prettier */
import { Redirect, Route } from 'react-router-dom';
import { isEmpty, isLoaded } from 'react-redux-firebase';
import { useSelector } from 'react-redux';
import LoadingPage from '../loading/LoadingPage';
import React from 'react';

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated or if auth is not
// yet loaded
export default function RequireAuth({ children, ...rest }: any) {
  const auth = useSelector((state: any) => {
    return state.firebase.auth;
  });
  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (!isLoaded(auth)) {
          return <LoadingPage />;
        }
        if (!isEmpty(auth)) {
          return children;
        }
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
}
